import React from 'react'

export default props => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      stroke="#00112B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.1009 12.8634L10.1009 2.82922"
    />
    <path
      stroke="#00112B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.5312 10.4236L10.1013 12.8636L7.67125 10.4236"
    />
    <path
      stroke="#00112B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.9611 6.77332H14.7386C16.4344 6.77332 17.8086 8.14748 17.8086 9.84415V13.9141C17.8086 15.6058 16.4378 16.9767 14.7461 16.9767H5.46276C3.76693 16.9767 2.39193 15.6016 2.39193 13.9058L2.39193 9.83498C2.39193 8.14415 3.76359 6.77332 5.45443 6.77332L6.23943 6.77332"
    />
  </svg>
)
